import React, { useState, useEffect } from "react";
import {
  Row,
  Col,
  Card,
  Tag,
  message,
  Descriptions,
  Button,
  Tabs,
  Spin,
  Typography,
} from "antd";
import { useParams, Link } from "react-router-dom";
import {
  UserOutlined,
  CarOutlined,
  ArrowRightOutlined,
} from "@ant-design/icons";
import axios from "axios";

const { TabPane } = Tabs;
const { Title } = Typography;

const CustomerAgreementDetail = () => {
  const { id } = useParams();
  const [agreementData, setAgreementData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchAgreementDetails();
  }, [id]);

  const fetchAgreementDetails = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`http://93.127.203.113:5005/customer-agreements/${id}`);
      setAgreementData(response.data);
    } catch (error) {
      message.error("Failed to fetch agreement details.");
    } finally {
      setLoading(false);
    }
  };

  /** ✅ Ensures images render correctly */
  const renderImage = (src, alt) => {
    if (!src) return <p style={{ textAlign: "center", color: "#999" }}>No Image Available</p>;

    const imageUrl = `http://93.127.203.113:5005${src.replace(/\\/g, "/")}`;
    return (
      <img
        src={imageUrl}
        alt={alt}
        style={{
          width: "100%",
          height: "300px",
          objectFit: "cover",
          borderRadius: "10px",
        }}
        onError={(e) => { e.target.src = "https://via.placeholder.com/300"; }} // Fallback image
      />
    );
  };

  return (
    <div style={{ padding: "20px" }}>
      {loading ? (
        <div style={{ textAlign: "center", marginTop: "50px" }}>
          <Spin size="large" />
        </div>
      ) : (
        <Card
          style={{
            borderRadius: "10px",
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
            borderTop: "5px solid #0c8c49",
          }}
        >
          <Title level={4} style={{ color: "#0c8c49", marginBottom: "20px" }}>
            Customer Agreement Details
          </Title>
          <Tabs defaultActiveKey="1" type="card">
            {/* Agreement Overview */}
            <TabPane tab={<span><ArrowRightOutlined /> Agreement Overview</span>} key="1">
              <Row gutter={[24, 24]}>
                <Col span={24} md={12}>
                  <Card title="Agreement Information" bordered={false}
                    style={{ borderRadius: "10px", boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)" }}
                  >
                    <Descriptions bordered column={1}>
                      <Descriptions.Item label="Passenger Name">
                        {agreementData?.passenger
                          ? `${agreementData.passenger.firstName} ${agreementData.passenger.lastName}`
                          : "N/A"}
                      </Descriptions.Item>
                      <Descriptions.Item label="Vehicle">
                        {agreementData?.vehicle
                          ? `${agreementData.vehicle.plateNumber} (${agreementData.vehicle.model})`
                          : "N/A"}
                      </Descriptions.Item>
                      <Descriptions.Item label="Price Per Day">
                        <Tag color="#0c8c49">${agreementData?.pricePerDay}</Tag>
                      </Descriptions.Item>
                      <Descriptions.Item label="Start Date">
                        {agreementData?.startDate
                          ? new Date(agreementData.startDate).toLocaleDateString()
                          : "N/A"}
                      </Descriptions.Item>
                      <Descriptions.Item label="End Date">
                        {agreementData?.endDate
                          ? new Date(agreementData.endDate).toLocaleDateString()
                          : "N/A"}
                      </Descriptions.Item>
                    </Descriptions>
                  </Card>
                </Col>
                <Col span={24} md={12}>
                  <Card title="Agreement Document" bordered={false}
                    style={{ borderRadius: "10px", boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)" }}
                  >
                    {agreementData?.agreementDocument ? (
                      <div style={{ textAlign: "center", marginBottom: "20px" }}>
                        {renderImage(agreementData.agreementDocument, "Agreement Document")}
                      </div>
                    ) : (
                      <div style={{ textAlign: "center", color: "#999" }}>
                        <p>No Agreement Document Available</p>
                      </div>
                    )}
                  </Card>
                </Col>
              </Row>
            </TabPane>

            {/* Passenger Information */}
            <TabPane tab={<span><UserOutlined /> Passenger Information</span>} key="2">
              <Card title="Passenger Details" bordered={false}
                extra={
                  agreementData?.passenger && (
                    <Link to={`/passengerDetails/${agreementData.passenger.id}`}>
                      <Button type="link" style={{ color: "#0c8c49" }}>Go to Detail</Button>
                    </Link>
                  )
                }
                style={{ borderRadius: "10px", boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)" }}
              >
                <Descriptions bordered column={1}>
                  <Descriptions.Item label="Name">
                    {agreementData?.passenger
                      ? `${agreementData.passenger.firstName} ${agreementData.passenger.lastName}`
                      : "N/A"}
                  </Descriptions.Item>
                  <Descriptions.Item label="Phone Number">
                    {agreementData?.passenger?.phoneNumber || "N/A"}
                  </Descriptions.Item>
                  <Descriptions.Item label="Rating">
                    {agreementData?.passenger?.rating || "N/A"}
                  </Descriptions.Item>
                  <Descriptions.Item label="Verified">
                    {agreementData?.passenger?.verified ? "Yes" : "No"}
                  </Descriptions.Item>
                </Descriptions>
              </Card>
            </TabPane>

            {/* Vehicle Information */}
            <TabPane tab={<span><CarOutlined /> Vehicle Information</span>} key="3">
              <Card title="Vehicle Details" bordered={false}
                extra={
                  agreementData?.vehicle && (
                    <Link to={`/vehicleDetails/${agreementData.vehicle.id}`}>
                      <Button type="link" style={{ color: "#0c8c49" }}>Go to Detail</Button>
                    </Link>
                  )
                }
                style={{ borderRadius: "10px", boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)" }}
              >
                <Descriptions bordered column={1}>
                  <Descriptions.Item label="Plate Number">{agreementData?.vehicle?.plateNumber || "N/A"}</Descriptions.Item>
                  <Descriptions.Item label="Model">{agreementData?.vehicle?.model || "N/A"}</Descriptions.Item>
                  <Descriptions.Item label="Color">{agreementData?.vehicle?.color || "N/A"}</Descriptions.Item>
                  <Descriptions.Item label="Manufactured Year">{agreementData?.vehicle?.manufacturedYear || "N/A"}</Descriptions.Item>
                </Descriptions>
              </Card>
            </TabPane>

          </Tabs>
        </Card>
      )}
    </div>
  );
};

export default CustomerAgreementDetail;
